import { Defaults } from 'es-decorators'
import { FormView } from '../form-view'
import { format } from 'helpers/declination-helper'
import { getTemplate } from 'helpers/template-helper'
import { getFormattedPhoneNumber } from 'helpers/tel-helpers'
import { RefundFormView } from './refund-form-view'
import { MobilePopupFillView } from 'mobile/es6/common/views/mobile-popup-fill-view'
import { Popup } from 'es6/libs/popup'
import { positionCenterOfWindow } from 'helpers/popup-positioning-helper'
import { COUNTERPARTY_TYPES } from 'es6/constants'
import filter from 'lodash/filter'
import { handleFieldInput } from 'helpers/input-helper'

@Defaults({
  el: '.refund-popup-wrap',
  formElement: '.common-refund-field',
  formName: 'refund',
  events: {
    'click .js-btn-refund': 'initPopup',
    'click .repeat-btn': 'onRepeatBtnClick',
    'click #send-demand': 'sendDemand',
    'click #get-code': 'prepareToSendData',
    'input #refund-sum': 'validationInput',
    'input #refund-pin': 'handlePinChange',
    'click .js-open-another-form': 'triggerOpenAnotherForm',
  },
  additionalOptions: [
    'fader',
    'userPhone',
    'userId',
    'isMobile',
    'bodyView',
    'isMobilePopup',
  ],
  formTypes: {
    '1': ['individual'],
    '2': ['entity'],
    '3': ['individual', 'entity'],
  },
  bankDataKey: 'bank_detail',
  OUR_LEGAL_ENTITY_ID: 2,
  REPEAT_PIN_REQUEST_DELAY: 31,
})
/**
 * Вью попапа формы запроса денежных средств.
 */
export class RefundPopupView extends FormView {
  /**
   * @inheritDoc
   */
  run () {
    this.template = getTemplate('#refund-form-template')
    this.codeConfirmationTemplate = getTemplate('#code-confirmation')
    this.userPhoneFormatted = getFormattedPhoneNumber(this.userPhone)
    this.$formElement = this.$('#form-place')
    this.childViews.refundForms = []
    this.listenTo(this, 'prepare-popup', this.preparePopup)
  }

  /**
   * Подготовка попапа.
   * @param {Object} counterparty - модель данных контрагента.
   */
  preparePopup (counterparty) {
    this.counterparty = counterparty
    this.counterpartyId = counterparty.id
    const refundFormType = this.counterparty.get('refund_form_type')
    this.$formElement.html(this.template({
      formType: refundFormType,
      COUNTERPARTY_TYPES: COUNTERPARTY_TYPES,
      phone: this.userPhoneFormatted,
      title: this.counterparty.get('name'),
    }))
    this.formTypes[refundFormType].forEach(formType => {
      this.childViews.refundForms.push(
        new RefundFormView({
          el: this.$('.js-fields-' + formType),
          model: this.model,
          formName: formType,
        })
      )
    })
    this.model.fetchLastSavedData(this.counterpartyId)
    if (!this.popup) {
      this.initPopup()
    }
    this.updateFieldsList()
  }

  /**
   * Инициализация попапа
   */
  initPopup () {
    if (this.isMobile) {
      this.popup = new MobilePopupFillView({
        el: this.$el,
        bodyView: this.bodyView,
      }).popup
    } else {
      this.popup = new Popup(this.$el, this.opener)
      this.popup.addEventListener(
        Popup.EventType.BEFORE_OPEN,
        this.handlePopupOpen.bind(this)
      )
    }
    this.popup.addEventListener(
      Popup.EventType.BEFORE_CLOSE,
      this.handlePopupClose.bind(this)
    )
  }

  /**
   * Метод обновляет значение таймера и показывает кнопку "Прислать повторно", по истечении 30 секунд
   */
  tick () {
    this.timer -= 1
    if (this.timer > 0) {
      this.$('#timer').text(this.timer + ' '
        + format(this.timer, ['секунда', 'секунды', 'секунд']))
      setTimeout(this.tick.bind(this), 1000)
    } else {
      this.$('.repeat-btn').addClass('visible')
    }
  }

  /**
   * Выполняется перед открытием попапа
   */
  handlePopupOpen () {
    this.fader.show()
    positionCenterOfWindow(this.$el)
  }

  /**
   * Выполняется перед закрытием попапа
   */
  handlePopupClose () {
    if (!this.isMobile) {
      this.fader.hide()
    }
    this.model.clear()
    this.childViews.refundForms.forEach(refundFormView => {
      refundFormView.remove()
    })
    this.childViews.refundForms = []
  }

  /**
   * Обработчик клика на кнопке "Прислать повторно"
   * Скрывает кнопку и вызывает метод, управляющий таймером
   */
  onRepeatBtnClick () {
    this.updateFieldsList()
    this.clearErrors()
    this.timer = this.REPEAT_PIN_REQUEST_DELAY
    this.tick()
    this.$('.repeat-btn').removeClass('visible')
    this.model.requestNewPin()
  }

  /**
   * Показывает форму для ввода кода-подтверждения
   */
  showConfirmation () {
    this.$formElement.html(this.codeConfirmationTemplate({
      phone: this.userPhoneFormatted,
      timer: this.timer,
      isMobile: this.isMobile,
    }))
  }

  /**
   * Показ попапа "Заявка успешно отправлена"
   */
  showDemandSuccessfullySaved () {
    this.popup.close()
    this.successPopup = new Popup($('.refund-demand-sent'), $('#send-demand'))
    this.successPopup.open()
  }

  /**
   * Отправка PIN.
   */
  sendDemand () {
    this.model.save(
      { pin: this.$('#refund-pin').val() },
      {
        success: this.showDemandSuccessfullySaved.bind(this),
        error: this.error.bind(this),
      }
    )
  }

  /**
   * Сохранение банковских данных в модель.
   * @param {Object} data - объект атрибутов для сохранения в модели.
   */
  saveBankData (data) {
    this.model.save(data, {
      success: this.showConfirmation.bind(this),
      error: this.error.bind(this),
    })
  }

  /**
   * Подготовка данных формы для отправки на сервер.
   */
  prepareToSendData () {
    const formData = {}
    formData[this.bankDataKey] = {}
    this.childViews.refundForms.forEach(refundFormView => {
      refundFormView.clearErrors()
      formData[this.bankDataKey][refundFormView.formName] = refundFormView.getData()
    })
    formData.counterparty_id = this.counterpartyId
    formData.our_legal_entity_id = this.OUR_LEGAL_ENTITY_ID
    const commonFormData = this.getData()
    commonFormData.sum = Number(commonFormData.sum)

    this.clearErrors()
    this.saveBankData({ ...commonFormData, ...formData })
  }

  /**
   * @inheritDoc
   */
  fillErrors (errors) {
    const commonErrors = filter(errors, error => error.field.indexOf('.') === -1)
    if (commonErrors) {
      commonErrors.forEach(commonError => {
        commonError.message = commonError.messages[0]
      })
      super.fillErrors(commonErrors)
    }
    this.childViews.refundForms.forEach(refundFormView => {
      refundFormView.fillErrors(errors)
    })
  }

  /**
   * Вызывает функцию для валидации ввода символов
   * @param {Event} event Событие input
   */
  validationInput (event) {
    handleFieldInput(event, 'sum', true)
  }

  /**
   * Обработка ввода PIN хелпером.
   * @param {Event} event Событие input
   */
  handlePinChange (event) {
    handleFieldInput(event)
  }

  /**
   * Триггерит событие open-another-form и закрывает попап.
   * @param {Event} e Событие клика по кнопке.
   */
  triggerOpenAnotherForm (e) {
    e.preventDefault()
    e.stopPropagation()
    this.popup.close()
    this.trigger('open-another-form', this.counterpartyId)
  }
}
